import _extends from "@babel/runtime/helpers/esm/extends";
import ssoActionsV1 from './actions.v1';
import ssoActionsV2 from './actions.v2';
export default ((store, api, sharedActions) => {
  return _extends({}, ssoActionsV1(store, api, sharedActions), ssoActionsV2(store, api, sharedActions));
});